module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-180.7816a11a.jpg";